import React from 'react';

import classes from '../Spinner/Spinner.module.css';

const Spinner = () => <div className={ classes.spinner }>
  <div className={ classes.side }/>
  <div className={ classes.side }/>
  <div className={ classes.side }/>
  <div className={ classes.side }/>
  <div className={ classes.side }/>
  <div className={ classes.side }/>
  <div className={ classes.side }/>
  <div className={ classes.side }/>
</div>;

export default Spinner;
